import React, { useState, useMemo, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import menuData from "../JSON/db.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";

const Sidebar = () => {
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(null);
  const menuItems = useMemo(() => menuData, []);

  useEffect(() => {
    const storedActiveMenu = localStorage.getItem("activeMenu");
    if (storedActiveMenu) {
      setActiveMenu(storedActiveMenu);
    }
  }, []);

  useEffect(() => {
    Object.entries(menuItems).forEach(([_, menus]) => {
      menus.forEach((menu) => {
        if (menu.sub_options) {
          menu.sub_options.forEach((sub) => {
            const subPath = `/${menu.route.toLowerCase()}-${sub.name.toLowerCase()}`;
            if (location.pathname === subPath) {
              setActiveMenu(menu.route);
              localStorage.setItem("activeMenu", menu.route);
            }
          });
        }
      });
    });
  }, [location.pathname, menuItems]);

  const toggleMenu = (route) => {
    const newActiveMenu = activeMenu === route ? null : route;
    setActiveMenu(newActiveMenu);
    localStorage.setItem("activeMenu", newActiveMenu || "");
  };

  return (
    <aside>
      {Object.entries(menuItems).map(([section, menus]) => (
        <div key={section}>
          <div className="sidebar-heading">{section}</div>
          <ul style={{ listStyle: "none", padding: 0 }}>
            {menus.map((menu) => {
              const isActive = activeMenu === menu.route;
              const isCurrentPath = location.pathname.includes(
                menu.route.toLowerCase()
              );

              return (
                <li key={menu.route}>
                  {menu.sub_options && menu.sub_options.length > 0 ? (
                    <div>
                      <div
                        onClick={() => toggleMenu(menu.route)}
                        className="menu-title"
                      >
                        <span>
                          <i
                            className={`fa ${menu.icon}`}
                            style={{ marginRight: "20px" }}
                          ></i>
                          {menu.name}
                        </span>
                        <span className="arrow-icon">
                          {isActive ? (
                            <FontAwesomeIcon icon={faAngleDown} />
                          ) : (
                            <FontAwesomeIcon icon={faAngleRight} />
                          )}
                        </span>
                      </div>
                      <ul
                        className="menu-sub-items"
                        style={{
                          maxHeight: isActive ? "200px" : "0px",
                          marginBottom: "5px",
                          overflow: "hidden",
                          transition: "max-height 0.3s ease-in-out",
                        }}
                      >
                        {menu.sub_options.map((sub) => {
                          const subPath = `/${menu.route.toLowerCase()}-${sub.name.toLowerCase()}`;
                          const isSubActive = location.pathname === subPath;

                          return (
                            <li
                              key={sub.name}
                              className={
                                isSubActive ? "menu-sub-active-Class" : ""
                              }
                              style={{
                                padding: "10px 17px",
                                fontSize: "12px",
                                fontWeight: "500",
                                marginTop: "5px",
                                marginBottom: "5px",
                              }}
                            >
                              <Link
                                to={subPath}
                                style={{
                                  textDecoration: "none",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  width: "100%",
                                  color: "inherit",
                                }}
                              >
                                <span
                                  style={{
                                    marginRight: "10px",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  •
                                </span>
                                <span style={{ flexGrow: 1 }}>
                                  {sub.name.replace(/-/g, " ")}
                                </span>
                                <span
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    marginLeft: "auto",
                                  }}
                                >
                                  →
                                </span>
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  ) : (
                    <Link
                      to={`/${menu.route.toLowerCase()}`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "9px 20px",
                        textDecoration: "none",
                        color: isCurrentPath ? "black" : "white",
                        background: isCurrentPath
                          ? "rgb(255, 215, 0)"
                          : "transparent",
                        borderRadius: "1px",
                        transition: "background 0.3s",
                        fontSize: "13px",
                        marginTop: "9px",
                      }}
                    >
                      <i
                        className={menu.icon}
                        style={{ marginRight: "10px" }}
                      ></i>
                      <span>{menu.name}</span>
                    </Link>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </aside>
  );
};

export default Sidebar;
